import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import IEmptyStateConfig, { EmptyStateType } from "../types/emptyState";

const EmptyState = ({
  type = EmptyStateType.DEFAULT,
  customDescription,
  children
}: {
  type?: EmptyStateType;
  customDescription?: string;
  children?: React.ReactNode;
}) => {
  return (
    <Flex flexDirection="column" alignItems="center" p="8" textAlign="center">
      <Box width={"125px"} height={"125px"}>
        {content[type].illustration}
      </Box>
      <Box pt="8" fontSize="lg" fontWeight="semibold" color="gray.500">
        {content[type].title}
      </Box>
      {(customDescription || content[type].description) && (
        <Box pt="2" color="gray.500">
          {customDescription || content[type].description}
        </Box>
      )}
      {children && <Box pt="8">{children}</Box>}
    </Flex>
  );
};

const NoData = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      width="100%"
      height="100%"
      viewBox="0 0 647.63626 632.17383"
    >
      <path
        d="M687.3279,276.08691H512.81813a15.01828,15.01828,0,0,0-15,15v387.85l-2,.61005-42.81006,13.11a8.00676,8.00676,0,0,1-9.98974-5.31L315.678,271.39691a8.00313,8.00313,0,0,1,5.31006-9.99l65.97022-20.2,191.25-58.54,65.96972-20.2a7.98927,7.98927,0,0,1,9.99024,5.3l32.5498,106.32Z"
        transform="translate(-276.18187 -133.91309)"
        fill="#f2f2f2"
      />
      <path
        d="M725.408,274.08691l-39.23-128.14a16.99368,16.99368,0,0,0-21.23-11.28l-92.75,28.39L380.95827,221.60693l-92.75,28.4a17.0152,17.0152,0,0,0-11.28028,21.23l134.08008,437.93a17.02661,17.02661,0,0,0,16.26026,12.03,16.78926,16.78926,0,0,0,4.96972-.75l63.58008-19.46,2-.62v-2.09l-2,.61-64.16992,19.65a15.01489,15.01489,0,0,1-18.73-9.95l-134.06983-437.94a14.97935,14.97935,0,0,1,9.94971-18.73l92.75-28.4,191.24024-58.54,92.75-28.4a15.15551,15.15551,0,0,1,4.40966-.66,15.01461,15.01461,0,0,1,14.32032,10.61l39.0498,127.56.62012,2h2.08008Z"
        transform="translate(-276.18187 -133.91309)"
        fill="#3f3d56"
      />
      <path
        d="M398.86279,261.73389a9.0157,9.0157,0,0,1-8.61133-6.3667l-12.88037-42.07178a8.99884,8.99884,0,0,1,5.9712-11.24023l175.939-53.86377a9.00867,9.00867,0,0,1,11.24072,5.9707l12.88037,42.07227a9.01029,9.01029,0,0,1-5.9707,11.24072L401.49219,261.33887A8.976,8.976,0,0,1,398.86279,261.73389Z"
        transform="translate(-276.18187 -133.91309)"
        fill="#5686fc"
      />
      <circle cx="190.15351" cy="24.95465" r="20" fill="#5686fc" />
      <circle cx="190.15351" cy="24.95465" r="12.66462" fill="#fff" />
      <path
        d="M878.81836,716.08691h-338a8.50981,8.50981,0,0,1-8.5-8.5v-405a8.50951,8.50951,0,0,1,8.5-8.5h338a8.50982,8.50982,0,0,1,8.5,8.5v405A8.51013,8.51013,0,0,1,878.81836,716.08691Z"
        transform="translate(-276.18187 -133.91309)"
        fill="#e6e6e6"
      />
      <path
        d="M723.31813,274.08691h-210.5a17.02411,17.02411,0,0,0-17,17v407.8l2-.61v-407.19a15.01828,15.01828,0,0,1,15-15H723.93825Zm183.5,0h-394a17.02411,17.02411,0,0,0-17,17v458a17.0241,17.0241,0,0,0,17,17h394a17.0241,17.0241,0,0,0,17-17v-458A17.02411,17.02411,0,0,0,906.81813,274.08691Zm15,475a15.01828,15.01828,0,0,1-15,15h-394a15.01828,15.01828,0,0,1-15-15v-458a15.01828,15.01828,0,0,1,15-15h394a15.01828,15.01828,0,0,1,15,15Z"
        transform="translate(-276.18187 -133.91309)"
        fill="#3f3d56"
      />
      <path
        d="M801.81836,318.08691h-184a9.01015,9.01015,0,0,1-9-9v-44a9.01016,9.01016,0,0,1,9-9h184a9.01016,9.01016,0,0,1,9,9v44A9.01015,9.01015,0,0,1,801.81836,318.08691Z"
        transform="translate(-276.18187 -133.91309)"
        fill="#5686fc"
      />
      <circle cx="433.63626" cy="105.17383" r="20" fill="#5686fc" />
      <circle cx="433.63626" cy="105.17383" r="12.18187" fill="#fff" />
    </svg>
  );
};

const NoErrors = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 524.67004 520.18759"
    >
      <path
        d="M524.67004,518.99758c0,.66003-.53003,1.19-1.19006,1.19H1.19c-.65997,0-1.19-.52997-1.19-1.19s.53003-1.19,1.19-1.19H523.47998c.66003,0,1.19006,.53003,1.19006,1.19Z"
        fill="#3f3d56"
      />
      <polygon
        points="362.54192 461.05879 368.54192 486.05879 350.54192 491.05879 346.54192 464.05879 362.54192 461.05879"
        fill="#ffb6b6"
      />
      <polygon
        points="391.54192 380.05879 372.54192 396.05879 360.54192 415.05879 377.54192 426.05879 406.54192 393.05879 391.54192 380.05879"
        fill="#ffb6b6"
      />
      <path
        d="M385.54192,215.05879l16,54s71,62,64,75c-7,13-54,49-54,49,0,0,3.48819,11.51181-6.75591,6.75591-10.24409-4.75591-21.24409-17.75591-21.24409-17.75591,0,0,0-10,5-8,5,2,28-25,28-25l-50-46v153.81496s12,10.49213,0,11.33858c-12,.84646-23,2.84646-23,2.84646,0,0-14-5-9-10l-15-82-11-100,8-52,69-12Z"
        fill="#2f2e41"
      />
      <path
        d="M353.54192,483.05879s1-4,5-4h12.21654s3.78346,17,2.78346,17,16,22-2,23c-18,1-23-1-23-1l-2-7.8937s-3-5.1063-2-9.1063,9-18,9-18Z"
        fill="#2f2e41"
      />
      <path
        d="M378.54192,418.05879s11.48556-.1811,8.74278,2.90945c-2.74278,3.09055-7.74278,8.09055-7.74278,8.09055,0,0-11.8942,24-17.4471,19.5-5.5529-4.5-14.5529-54.5-11.5529-60.5s7-6,7-6l18.44907,11.09552s-11.44907,27.90448,2.55093,24.90448Z"
        fill="#2f2e41"
      />
      <polygon
        points="350.54192 130.05879 354.54192 105.05879 327.54192 94.05879 323.54192 132.05879 350.54192 130.05879"
        fill="#ffb6b6"
      />
      <polygon
        points="350.54192 130.05879 354.54192 105.05879 327.54192 94.05879 323.54192 132.05879 350.54192 130.05879"
        opacity=".1"
      />
      <path
        d="M322.04192,126.55879l32-8,34,11s15,42,10,57c-5,15-5,44.29921-5,44.29921,0,0-.5-12.79921-29.5-3.79921-29,9-50,8-50,8l-1-36-12.56231-31.97679c-5.36947-13.66775,.41799-29.18571,13.42611-35.99949l8.6362-4.52372Z"
        fill="#e6e6e6"
      />
      <g>
        <path
          id="uuid-1b03a630-7e31-41b5-b302-96493ff31189-2376"
          d="M468.93625,244.36122c4.51538,5.40957,5.38427,12.12429,1.94111,14.99735-3.44316,2.87305-9.89353,.81637-14.40979-4.59574-1.83372-2.13717-3.12896-4.6824-3.77735-7.42276l-18.84239-23.1622,9.17843-7.42782,19.28065,22.56531c2.58106,1.12838,4.85427,2.85861,6.62935,5.04587Z"
          fill="#ffb6b6"
        />
        <polygon
          points="386.58903 129.87809 380.03103 155.85437 412.12807 207.23315 444.89428 240.16415 455.51447 231.35346 422.46915 190.23683 397.42099 137.25937 386.58903 129.87809"
          fill="#e6e6e6"
        />
      </g>
      <g>
        <ellipse
          cx="459.12853"
          cy="52.44806"
          rx="41.5"
          ry="52.5"
          transform="translate(-2.61679 33.98) rotate(-4.22648)"
          fill="#5686fc"
        />
        <rect
          x="460.12853"
          y="104.80549"
          width="2"
          height="199.43799"
          fill="#2f2e41"
        />
        <polygon
          points="462.62626 100.59386 462.86623 107.66085 466.05994 114.20304 452.73559 113.52346 458.33644 107.88988 457.70336 101.46854 462.62626 100.59386"
          fill="#5686fc"
        />
      </g>
      <g>
        <circle cx="343.71883" cy="85.56184" r="27.53355" fill="#ffb6b6" />
        <path
          d="M341.52141,48.54491c.79671,.46507,1.86389-.23857,2.11935-1.12501s-.04212-1.82761-.33722-2.70165l-1.48558-4.40008c-1.0536-3.12063-2.17183-6.35032-4.45368-8.72552-3.44408-3.58499-8.91753-4.497-13.84474-3.83628-6.3275,.84849-12.57056,4.27476-15.51267,9.94055-2.9421,5.66579-1.68954,13.5716,3.62665,17.10648-7.57673,8.68419-10.21786,18.36242-9.80083,29.87971,.41702,11.51729,12.96805,22.11696,21.153,30.23044,1.82785-1.10801,3.48957-6.30065,2.48442-8.18702s.435-4.07179-.80984-5.80934-2.28631,1.02915-1.0278-.69854c.79414-1.0902-2.30536-3.59827-1.12493-4.25078,5.70958-3.15606,7.60854-10.2728,11.19452-15.72263,4.32536-6.57351,11.72821-11.02516,19.56239-11.76369,4.31558-.40683,8.87377,.33002,12.41109,2.83544,3.53731,2.50542,5.82735,6.98256,5.00708,11.23896,2.12436-2.157,3.18182-5.31809,2.78297-8.31917-.39885-3.00108-2.24525-5.77623-4.85926-7.3035,1.58943-5.25615,.22781-11.30225-3.46132-15.36964s-18.65428-3.37463-24.04014-2.30417"
          fill="#2f2e41"
        />
        <path
          d="M340.68501,68.64111c-7.1334,.77005-12.28392,6.94917-16.63311,12.65557-2.50677,3.28904-5.13259,6.92124-5.06965,11.05618,.06363,4.18054,2.85874,7.76625,4.19457,11.72813,2.18345,6.47581,.05542,14.18053-5.14218,18.61771,5.13581,.97458,10.68776-2.87625,11.57437-8.02797,1.03212-5.99724-3.51408-11.7855-2.97566-17.84704,.47435-5.34029,4.68273-9.45028,8.26047-13.4432,3.57775-3.99292,6.93788-9.29143,5.29193-14.39384"
          fill="#2f2e41"
        />
      </g>
      <path
        d="M314.42637,234.55793H108.75752c-23.32296,0-42.22995,18.90699-42.22995,42.22995v199.43289c0,23.32291,18.90695,42.22986,42.22986,42.22986h205.66894c23.32296,0,42.22995-18.90699,42.22995-42.22995v-199.43281c0-23.32296-18.90699-42.22995-42.22995-42.22995Z"
        fill="#fff"
      />
      <path
        d="M314.42649,519.45019H108.75754c-23.83691,0-43.22998-19.39258-43.22998-43.22949v-199.43262c0-23.83691,19.39307-43.22998,43.22998-43.22998h205.66895c23.83691,0,43.22998,19.39307,43.22998,43.22998v199.43262c0,23.83691-19.39307,43.22949-43.22998,43.22949ZM108.75754,235.5581c-22.73438,0-41.22998,18.49561-41.22998,41.22998v199.43262c0,22.73438,18.49561,41.22949,41.22998,41.22949h205.66895c22.73438,0,41.22998-18.49512,41.22998-41.22949v-199.43262c0-22.73437-18.49561-41.22998-41.22998-41.22998H108.75754Z"
        fill="#3f3d56"
      />
      <circle cx="292.72497" cy="249.4082" r="4.76903" fill="#3f3d56" />
      <circle cx="305.83981" cy="249.4082" r="4.76903" fill="#3f3d56" />
      <circle cx="318.95465" cy="249.4082" r="4.76903" fill="#3f3d56" />
      <path
        d="M102.01538,448.63094c-1.48165,0-2.68692,1.20526-2.68692,2.68692,0,.72246,.27901,1.39069,.78543,1.88399,.51079,.52304,1.1799,.80293,1.90148,.80293h215.09838c1.48165,0,2.68692-1.20526,2.68692-2.68692,0-.72246-.27901-1.39069-.78543-1.88399-.51079-.52304-1.1799-.80293-1.90148-.80293H102.01538Z"
        fill="#e6e6e6"
      />
      <path
        d="M217.02966,447.7353v7.16511H102.01538c-.98518,0-1.88082-.39414-2.52565-1.0569-.66287-.64483-1.0569-1.54047-1.0569-2.52565,0-1.97047,1.61219-3.58255,3.58255-3.58255h115.01428Z"
        fill="#5686fc"
      />
      <path
        d="M312.63557,434.30072h-35.82554c-3.95078,0-7.16511-3.21345-7.16511-7.16511s3.21433-7.16511,7.16511-7.16511h35.82554c3.95078,0,7.16511,3.21345,7.16511,7.16511s-3.21433,7.16511-7.16511,7.16511Z"
        fill="#e6e6e6"
      />
      <g>
        <polyline
          points="178.04436 439.42158 153.00042 355.27363 151.08342 355.84395 176.03948 439.696"
          fill="#2f2e41"
        />
        <ellipse
          cx="175.04192"
          cy="195.55879"
          rx="41.5"
          ry="52.5"
          transform="translate(-13.93649 13.43225) rotate(-4.22648)"
          fill="#5686fc"
        />
        <rect
          x="176.04192"
          y="247.91621"
          width="2"
          height="199.43799"
          fill="#2f2e41"
        />
        <polygon
          points="154.12589 352.83568 156.37116 359.54081 161.29787 364.90062 148.33299 368.04891 152.09477 361.05206 149.65683 355.07788 154.12589 352.83568"
          fill="#5686fc"
        />
        <polygon
          points="178.53965 243.70459 178.77961 250.77158 181.97332 257.31377 168.64898 256.63419 174.24983 251.0006 173.61675 244.57926 178.53965 243.70459"
          fill="#5686fc"
        />
        <ellipse
          cx="136.04192"
          cy="305.55879"
          rx="41.5"
          ry="52.5"
          transform="translate(-100.19337 68.77521) rotate(-20.93384)"
          fill="#5686fc"
        />
      </g>
      <path
        id="uuid-b40723c2-846b-43d4-8d7a-d7be28bdc184-2377"
        d="M336.50935,224.32158c6.7457,2.0366,11.16281,7.16803,9.866,11.46082-1.29681,4.29279-7.81569,6.12073-14.56352,4.0825-2.70665-.77722-5.18781-2.19132-7.2359-4.12401l-28.47282-8.99009,3.58382-11.25044,28.51078,8.25056c2.77637-.4763,5.62645-.28063,8.31164,.57066Z"
        fill="#ffb6b6"
      />
      <path
        d="M287.04192,150.55879l30-22-1,42-28,36,30,12-1,17.13379s-38-9.13379-44-10.13379-11-15-11-15l25-60Z"
        fill="#e6e6e6"
      />
    </svg>
  );
};

const SadFace = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    width="100%"
    height="100%"
    viewBox="0 0 1100.02 811.41"
  >
    <defs>
      <linearGradient
        id="785c60ff-874e-47fc-85e9-4f7317d8d736-35"
        x1="942.13"
        y1="802.28"
        x2="942.13"
        y2="308.24"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="gray" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="gray" stop-opacity="0.12" />
        <stop offset="1" stop-color="gray" stop-opacity="0.1" />
      </linearGradient>
    </defs>
    <title>feeling blue</title>
    <path
      d="M61.83,433.31C79.2,500.44,115.94,558.47,174,586.6c120.7,58.46,392.91,28.31,596.07-6.3C875.16,562.4,967.53,513,1034.63,443.48Z"
      transform="translate(-49.99 -44.29)"
      fill="#5686fc"
      opacity="0.1"
    />
    <path
      d="M1127.19,117.32H1015.72c-5.29,0-9.63-3.92-9.63-8.71s4.34-8.72,9.63-8.72H1035c-5.3,0-9.63-3.92-9.63-8.72s4.33-8.71,9.63-8.71h-13.76c-5.3,0-9.64-3.92-9.64-8.72s4.34-8.71,9.64-8.71h58.18c-12.91-5.43-28-9.29-45.39-11.32C875.38,35.28,818.74,47.47,798.76,60a234.52,234.52,0,0,1-81.54,32.34c-97.88,18.27-280.93,40.25-446.84-7C187.92,61.81,126.63,101.52,89.9,167.9H1146.55c-1.38-19.29-5.51-37.11-13.09-52.7A10.17,10.17,0,0,1,1127.19,117.32Z"
      transform="translate(-49.99 -44.29)"
      fill="#5686fc"
      opacity="0.1"
    />
    <path
      d="M52.38,293.19A402.53,402.53,0,0,0,56.7,410.31l978.68,32.39a415.21,415.21,0,0,0,68-93.82Zm387.08,83.55H420.19c5.3,0,9.64,3.93,9.64,8.72s-4.34,8.71-9.64,8.71H308.72c-5.29,0-9.63-3.92-9.63-8.71s4.34-8.72,9.63-8.72H328c-5.3,0-9.63-3.92-9.63-8.71s4.33-8.72,9.63-8.72H314.23c-5.3,0-9.64-3.92-9.64-8.71s4.34-8.72,9.64-8.72H425.7c5.3,0,9.63,3.92,9.63,8.72s-4.33,8.71-9.63,8.71h13.76c5.3,0,9.63,3.92,9.63,8.72S444.76,376.74,439.46,376.74Z"
      transform="translate(-49.99 -44.29)"
      fill="#5686fc"
      opacity="0.1"
    />
    <path
      d="M1146.59,168.5,78.11,192c-13,30.23-21.62,64.41-25.59,99.83H1127.87a379.29,379.29,0,0,0,15.52-63.63C1146.6,207.39,1147.88,187.26,1146.59,168.5ZM269.46,245.55H250.19c5.3,0,9.64,3.93,9.64,8.72s-4.34,8.72-9.64,8.72H138.72c-5.29,0-9.63-3.93-9.63-8.72s4.34-8.72,9.63-8.72H158c-5.3,0-9.63-3.92-9.63-8.71s4.33-8.72,9.63-8.72H144.23c-5.3,0-9.64-3.92-9.64-8.71s4.34-8.72,9.64-8.72H255.7c5.3,0,9.63,3.92,9.63,8.72s-4.33,8.71-9.63,8.71h13.76c5.3,0,9.63,3.93,9.63,8.72S274.76,245.55,269.46,245.55Z"
      transform="translate(-49.99 -44.29)"
      fill="#5686fc"
      opacity="0.1"
    />
    <ellipse
      cx="545.08"
      cy="739.96"
      rx="446.98"
      ry="41.12"
      fill="#5686fc"
      opacity="0.1"
    />
    <path
      d="M1050.63,444.61a1.48,1.48,0,0,1,0-.21c0-.11,0-.21,0-.31h0a8.54,8.54,0,0,0-1.27-3.21,25.29,25.29,0,0,0-9.26-8.76c-6.6-3.62-15.67-5.17-18.31-12.08-.81-2.14-.83-4.47-1.23-6.71a20.29,20.29,0,0,0-13.39-15.23c-3.14-1.05-6.53-1.34-9.58-2.64-6.82-2.9-10.42-10.05-13.47-16.66q-5.92-12.8-11.84-25.61c-3,1.51-6.88.8-9.69-1.09a20.1,20.1,0,0,1-6.27-7.75c-4.07-7.9-5.82-16.85-10.6-24.37s-14.33-13.46-22.77-10.19a38.86,38.86,0,0,1-5.1,2.11c-7.23,1.69-15.23-6.57-21.42-2.56A7,7,0,0,0,894,312a1.2,1.2,0,0,1,0-.2,12.79,12.79,0,0,0-1.32,5.22v0c0,.37,0,.73,0,1.08,0,.06,0,.12,0,.18,0,1.44.09,2.9.11,4.36a19.43,19.43,0,0,1-.28,3.66l0-.1a12.32,12.32,0,0,1-.52,2c-1.61,4.32-6.07,7.15-8.16,11.21l0-.2a10.56,10.56,0,0,0-.61,1.37,10.2,10.2,0,0,0-.57,3.31c-.18,7.63,7.91,14.81,8.85,23,.67,5.8,2,7.66,6.93,10.94l1.08.72c-.43,0-.87.06-1.36.07a3.32,3.32,0,0,0-.57.06,6.1,6.1,0,0,0-5.14.9c-3.78,3-12.72.69-16.69,0s-17.57,1.17-19.47,8.71-5.16,23.1-5.16,23.1,0,9.87-1.21,11.71a.59.59,0,0,0,0,.4c0,2.77.1,19.42-2.58,23.71-.66,1-.61,3.21-.12,5.93-2.82,3.63-5.47,7.87-5,10.65.86,5.69,12.4,23.58,28.94,14,0,0,9.41-17.21-2.43-26.36l.51-2c3.58,4.4,6.23,7.56,6.23,7.56s.14.37.36,1h-.36a47,47,0,0,1,2.78,13.08,16,16,0,0,1-.88,4.81h.31c-.09.34-.19.68-.31,1a8.72,8.72,0,0,1-3.11,4.21c-8.27,5.86-17.74,47.71-17.74,47.71S837.75,596.45,834,600.3c-3.1,3.16,16.38,12.06,31,11a23.86,23.86,0,0,0,6-1.14c.09,1,.19,2,.29,2.91.31,3,.63,5.78.83,6.65.52,2.18,1.55,24.44,1.55,24.44s-2.11,14.46-1.6,24.52c0,.69.09,1.35.15,2l-1.82.28c-2.76,6.2,8.61,57.93,10.16,62.28a41.42,41.42,0,0,1,1.72,10.55s-1,3.68-.17,5.69a13.84,13.84,0,0,1,1,3.85s-.68,3.34.35,5.52-.17,6-.17,6-.34,15.07-3.44,23.27A13.4,13.4,0,0,0,882,801.4a8.21,8.21,0,0,0,.7.81s17.1.14,20.11,0l.39,0c1.21-.17,4.31-13.73,1.55-20.26s-.34-14.57-.34-14.57V755.5s3.1-2.86,0-9-2.59-8-2.59-8,3.45-9.88-.17-13.06.69-15.24.69-15.24L903.56,670a15.81,15.81,0,0,0-1.95-.5c-.07-.66-.14-1.34-.21-2.06-.71-7.28-1.32-17.18.26-20S904,620,904.25,602.89l15.76.6c.33,8,.68,15.3.9,16.23.52,2.18,1.56,24.44,1.56,24.44s-2.12,14.46-1.61,24.52c0,.69.09,1.35.15,2l-1.82.28c-2.76,6.2,8.61,57.93,10.16,62.28a41.65,41.65,0,0,1,1.73,10.55s-1,3.68-.18,5.69a13.84,13.84,0,0,1,1,3.85s-.68,3.34.35,5.52-.17,6-.17,6-.34,15.07-3.44,23.27a13.4,13.4,0,0,0,2.22,13.26,8.21,8.21,0,0,0,.7.81s17.1.14,20.11,0l.39,0c1.21-.17,4.31-13.73,1.55-20.26s-.34-14.57-.34-14.57V755.5s3.1-2.86,0-9-2.59-8-2.59-8,3.45-9.88-.17-13.06.69-15.24.69-15.24L952.44,670a15.36,15.36,0,0,0-2-.5c-.07-.66-.14-1.34-.21-2.06-.71-7.28-1.32-17.18.26-20,1.27-2.31,2-17.19,2.33-31.72,0-1,0-2,.08-3a155.09,155.09,0,0,0,21.58-2.42s-8.43-29.81-5.85-34.66c1.11-2.09-.49-13.22-2.68-25.21a17.52,17.52,0,0,0,10.78,3.9c3.77,7.25,15.24,23.93,21.7,26.5,7.58,3,1.89-23.6-1.72-27.45a32.39,32.39,0,0,1-4.28-6.87c.1-.12.21-.22.31-.33s.18-28.3-1.55-27.79-3.79-4.19-3.79-4.19l-5.34-46.87-2.24-19.62,0,0c1.87,1.38,4.09,2.26,6,3.63,5.2,3.81,6.9,10.5,9.18,16.42,1.88,4.87,4.52,9.7,8.85,12.76s10.68,3.87,15,.77c4-2.91,5.18-8.16,6.06-12.95,7.26,2.55,16.07-4.27,15.13-11.72-.23-1.84-.91-3.85.05-5.46,1.92-3.18,8-1.33,10-4.47a3.34,3.34,0,0,0,.5-1.81C1050.62,444.74,1050.63,444.68,1050.63,444.61Zm-97.11,25.78c-.11,1.79,2.35,16.17,4.35,27.55-1.64-7.09-4.93-14.66-11.41-19.85,0,0,0-.36-.08-1h.08s-.27-2.86-.31-6.93a76.34,76.34,0,0,1,.8-10.78v-.09h-.13c0-.3.08-.61.13-.91a32.5,32.5,0,0,1,2.43-8.74,24.23,24.23,0,0,1,1.85-3.14C952.3,456.17,953.62,468.58,953.52,470.39Zm5.38,33.32c.88,4.91,1.51,8.36,1.51,8.36l5.31,36.46v.17c-2.86-15.39-6.51-31.61-6.51-31.61A63,63,0,0,0,958.9,503.71Z"
      transform="translate(-49.99 -44.29)"
      fill="url(#785c60ff-874e-47fc-85e9-4f7317d8d736-35)"
    />
    <path
      d="M893.82,368.89c-1-9.24-11-17.21-8-26,1.63-4.79,6.73-7.72,8.45-12.48,1.14-3.14.63-6.59.64-9.93s.79-7.07,3.57-8.92c6-4,13.72,4.23,20.72,2.55a36.67,36.67,0,0,0,4.93-2.1c8.17-3.25,17.41,2.67,22,10.15s6.31,16.4,10.25,24.26a19.9,19.9,0,0,0,6.06,7.71c2.72,1.88,6.44,2.59,9.38,1.09l11.45,25.5c3,6.57,6.44,13.69,13,16.58,2.94,1.29,6.22,1.58,9.26,2.63a20,20,0,0,1,13,15.15c.39,2.24.4,4.56,1.19,6.69,2.55,6.88,11.32,8.42,17.71,12a24.77,24.77,0,0,1,9,8.71c1,1.73,1.86,4,.79,5.7-1.93,3.12-7.8,1.28-9.66,4.45-.94,1.6-.28,3.6,0,5.44.91,7.41-7.62,14.2-14.64,11.66-.85,4.77-2,10-5.86,12.89-4.15,3.1-10.3,2.28-14.49-.76s-6.73-7.85-8.55-12.7c-2.21-5.9-3.86-12.56-8.89-16.35-1.82-1.36-4-2.24-5.78-3.61-4-3.06-6-8.11-7.43-13-1.85-6.1-3.32-12.37-6-18.13s-6.92-11.12-12.73-13.75c-5.45-2.45-11.73-2.29-17.36-4.28-9.69-3.42-16.86-11.57-26.5-15.41a42.89,42.89,0,0,1-8.7-4.92C895.78,376.52,894.46,374.67,893.82,368.89Z"
      transform="translate(-49.99 -44.29)"
      fill="#3f3d56"
    />
    <g opacity="0.1">
      <path
        d="M894.72,328.45a10.12,10.12,0,0,0,.54-1.21c1.13-3.14.63-6.59.64-9.93a17.84,17.84,0,0,1,.31-3.32,14,14,0,0,0-1.31,6.32C894.89,323,895.21,325.82,894.72,328.45Z"
        transform="translate(-49.99 -44.29)"
      />
      <path
        d="M1018,479.48c-4.15,3.09-10.3,2.28-14.49-.77S996.77,470.87,995,466c-2.21-5.9-3.85-12.56-8.89-16.35-1.81-1.36-4-2.25-5.77-3.61-4-3.06-6-8.11-7.44-12.95-1.85-6.1-3.31-12.37-6-18.13s-6.91-11.12-12.73-13.75c-5.44-2.45-11.72-2.29-17.35-4.28-9.7-3.42-16.87-11.57-26.5-15.41a43.45,43.45,0,0,1-8.71-4.92c-4.74-3.27-6-5.12-6.7-10.89-1-8.66-9.8-16.21-8.43-24.37a12.68,12.68,0,0,0-.59,1.36c-3,8.8,7,16.77,8,26,.65,5.77,2,7.62,6.7,10.89a43.45,43.45,0,0,0,8.71,4.92c9.63,3.84,16.8,12,26.5,15.41,5.63,2,11.91,1.83,17.35,4.28,5.82,2.63,10,8,12.73,13.75s4.19,12,6,18.13c1.47,4.84,3.4,9.89,7.44,12.95,1.81,1.36,4,2.25,5.77,3.61,5,3.79,6.68,10.45,8.89,16.35,1.82,4.85,4.37,9.65,8.56,12.69s10.34,3.86,14.49.77c2.65-2,4-5.05,4.89-8.32A12.28,12.28,0,0,1,1018,479.48Z"
        transform="translate(-49.99 -44.29)"
      />
      <path
        d="M1038.55,449.49a4.21,4.21,0,0,0-.48,2.34c2.26-2.23,7.36-.92,9.14-3.79a3.65,3.65,0,0,0,.46-2.35C1045.35,447.89,1040.25,446.58,1038.55,449.49Z"
        transform="translate(-49.99 -44.29)"
      />
      <path
        d="M1023.86,466.59c-.19,1-.38,2.07-.62,3.11,6.12,1.91,13.19-3,14.19-9.2C1035,465.27,1029,468.46,1023.86,466.59Z"
        transform="translate(-49.99 -44.29)"
      />
    </g>
    <path
      d="M906.74,373.7s3.33,6.72-6.5,6.86,6.33,43.64,6.33,43.64L922.91,445l20.33-11,1.17-30.34,1.5-18.33s-19-6.17-15.5-14.33S906.74,373.7,906.74,373.7Z"
      transform="translate(-49.99 -44.29)"
      fill="#fbbebe"
    />
    <path
      d="M965.75,551.06s12,11.81,26-3.86L981,535.79H967.4Z"
      transform="translate(-49.99 -44.29)"
      fill="#575a89"
    />
    <path
      d="M967.05,535.79l-1.65,15.27s12,11.81,26-3.86"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M987.24,537.87s4.83,12.67,8.33,16.5,9,30.33,1.67,27.33-21.33-25.33-22.17-29.16-1.16-14.67-1.16-14.67Z"
      transform="translate(-49.99 -44.29)"
      fill="#fbbebe"
    />
    <polygon
      points="832.42 558.58 897.08 561.08 889.58 533.74 857.01 533.08 832.42 558.58"
      fill="#575a89"
    />
    <polygon
      points="841.41 558.58 906.08 561.08 898.58 533.74 866 533.08 841.41 558.58"
      opacity="0.1"
    />
    <path
      d="M903.57,648c-1.53,2.85-.94,12.71-.25,20,.44,4.64.92,8.21.92,8.21s-24.17,7.5-27.83,1c-.93-1.65-1.39-4.54-1.55-7.93-.5-10,1.55-24.41,1.55-24.41s-1-22.16-1.5-24.33c-.2-.87-.51-3.63-.81-6.62-.44-4.44-.86-9.38-.86-9.38l33-17.5s0,3.28-.06,8.33C906,611.23,905.47,644.5,903.57,648Z"
      transform="translate(-49.99 -44.29)"
      fill="#fbbebe"
    />
    <path
      d="M904.24,676.21s-24.17,7.5-27.83,1c-.93-1.65-1.39-4.54-1.55-7.93,5-.76,20.22-2.86,28.46-1.28C903.76,672.64,904.24,676.21,904.24,676.21Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M905.07,802.21l-.38,0c-2.91.11-19.45,0-19.45,0a9,9,0,0,1-.68-.8,13.64,13.64,0,0,1-2.15-13.2c3-8.17,3.33-23.17,3.33-23.17s1.17-3.83.17-6-.34-5.5-.34-5.5a14.25,14.25,0,0,0-1-3.83c-.83-2,.17-5.67.17-5.67a42.45,42.45,0,0,0-1.67-10.5c-1.5-4.33-12.5-55.83-9.83-62,0,0,23.33-4,32.17-1l-1.17,40s-4.17,12-.67,15.17.17,13,.17,13-.5,1.83,2.5,8,0,9,0,9v11.83s-2.33,8,.33,14.5S906.24,802,905.07,802.21Z"
      transform="translate(-49.99 -44.29)"
      fill="#3f3d56"
    />
    <path
      d="M950.86,648c-1.53,2.85-.94,12.71-.25,20,.44,4.64.92,8.21.92,8.21s-24.17,7.5-27.83,1c-.93-1.65-1.39-4.54-1.55-7.93-.5-10,1.55-24.41,1.55-24.41s-1-22.16-1.5-24.33c-.27-1.17-.74-12.33-1.11-22.34-.31-8.54-.56-16.26-.56-16.26l33,5.1s0,14.51-.41,29.42C952.76,630.92,952.09,645.74,950.86,648Z"
      transform="translate(-49.99 -44.29)"
      fill="#fbbebe"
    />
    <path
      d="M951.53,676.21s-24.17,7.5-27.83,1c-.93-1.65-1.39-4.54-1.55-7.93,5-.76,20.22-2.86,28.46-1.28C951.05,672.64,951.53,676.21,951.53,676.21Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M952.36,802.21l-.38,0c-2.91.11-19.45,0-19.45,0a9,9,0,0,1-.68-.8,13.64,13.64,0,0,1-2.15-13.2C932.7,780,933,765,933,765s1.17-3.83.17-6-.34-5.5-.34-5.5a14.25,14.25,0,0,0-1-3.83c-.83-2,.17-5.67.17-5.67a42.45,42.45,0,0,0-1.67-10.5c-1.5-4.33-12.5-55.83-9.83-62,0,0,23.33-4,32.17-1l-1.17,40s-4.17,12-.67,15.17.17,13,.17,13-.5,1.83,2.5,8,0,9,0,9v11.83s-2.33,8,.33,14.5S953.53,802,952.36,802.21Z"
      transform="translate(-49.99 -44.29)"
      fill="#3f3d56"
    />
    <circle cx="869.75" cy="313.77" r="23.5" opacity="0.1" />
    <circle cx="869.75" cy="312.77" r="23.5" fill="#fbbebe" />
    <path
      d="M873.24,604.54l33-17.5s0,3.28-.06,8.33c-4.82,2.88-12.09,7.21-19.08,11.3-3.8,2.23-7.51,4.39-10.69,6.2a14.2,14.2,0,0,1-2.31,1C873.66,609.48,873.24,604.54,873.24,604.54Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M953.53,587s0,14.51-.41,29.42H953a55.48,55.48,0,0,1-7.39-.23c-4.31-.46-7.76-1.6-9-3.86-2.51-4.4-9.54-10-15.48-14.17-.31-8.54-.56-16.26-.56-16.26Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M947.39,459.91a95.17,95.17,0,0,0-.48,19.63c15.16,12.5,12.33,38.83,12.33,38.83s11.67,53.34,9.17,58.17,5.66,34.5,5.66,34.5A145.51,145.51,0,0,1,953,613.46a55.48,55.48,0,0,1-7.39-.23c-4.31-.46-7.76-1.6-9-3.86-4.66-8.16-24.83-20.33-24.83-20.33S899,596.7,887.1,603.67c-3.8,2.23-7.51,4.39-10.69,6.2a19.84,19.84,0,0,1-8.35,2.29c-14.15,1.05-33-7.81-30-10.95,3.67-3.84,21.84-71.17,21.84-71.17s9.16-41.67,17.16-47.5a8.65,8.65,0,0,0,3-4.19c2.74-7.61-1.84-19.81-1.84-19.81s-25.83-31.83-24.67-33.67,1.17-11.66,1.17-11.66,3.17-15.5,5-23,15-9.34,18.83-8.67,12.49,3,16.15,0,9.84,1.17,9.84,1.17l15.18,4.18,13.65-8s13.68.7,14.85,2.53,19.17,5.34,19.17,5.34c9.16,6.16,8.83,35.5,8.83,35.5s-22,19.16-26.5,29A33.06,33.06,0,0,0,947.39,459.91Z"
      transform="translate(-49.99 -44.29)"
      fill="#575a89"
    />
    <path
      d="M971.24,418.2l5,4,5.17,46.5,5.16,46.67s2,4.67,3.67,4.17,1.5,27.66,1.5,27.66-19.14-11.77-26,3.86l-5.34-37.69s-6.84-38.5-6.67-41.5-3.5-35.5-3.5-35.5Z"
      transform="translate(-49.99 -44.29)"
      fill="#575a89"
    />
    <path
      d="M857.24,420.37l-3.67,4.5s.34,19.33-2.5,24,7.84,32,11.84,30.33,13-44.33,13-44.83S857.24,420.37,857.24,420.37Z"
      transform="translate(-49.99 -44.29)"
      fill="#575a89"
    />
    <path
      d="M856.91,447.87s-11.67,11.83-10.84,17.5,12,23.48,28,13.91C874.07,479.28,888.91,451.37,856.91,447.87Z"
      transform="translate(-49.99 -44.29)"
      fill="#575a89"
    />
    <path
      d="M904.69,802.24c-2.91.11-19.45,0-19.45,0a9,9,0,0,1-.68-.8C888.79,800,897.93,797.84,904.69,802.24Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M952,802.24c-2.91.11-19.45,0-19.45,0a9,9,0,0,1-.68-.8C936.08,800,945.22,797.84,952,802.24Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M888.28,509.11c-2.55,24.46-1.71,73-1.18,94.56-3.8,2.23-7.51,4.39-10.69,6.2a19.84,19.84,0,0,1-8.35,2.29C867,605.64,881.68,538.67,888.28,509.11Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M891.4,495.23c-.07.35-1.28,5.67-3.12,13.88C889,502.1,890,497.07,891.4,495.23Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M932,492.59s14.17,89-27.79,100C904.2,592.55,933.24,588.14,932,492.59Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M953,613.46a55.48,55.48,0,0,1-7.39-.23L934.29,491.54C941.51,496.26,950.15,582.62,953,613.46Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M902.24,343.24a6.19,6.19,0,0,1,2.23.23,9.73,9.73,0,0,1,2.82,2.12,10.05,10.05,0,0,0,9.54,1.85,12.58,12.58,0,0,1,3.59-1c1.91,0,3.56,1.4,4.55,3s1.5,3.5,2.35,5.21,2.21,3.33,4.08,3.75A7.14,7.14,0,0,1,934,359a3.68,3.68,0,0,1,1.12,1.55c1.56,3.37,2.8,7.35,6.13,9a9.17,9.17,0,0,0,3.91.85,8.17,8.17,0,0,0,4-.72,7.66,7.66,0,0,0,2.94-2.93c2.08-3.44,2.32-7.7,1.83-11.69A32.16,32.16,0,0,0,948.7,341a29.35,29.35,0,0,0-26.85-12.39,37.42,37.42,0,0,0-5.35,1c-6.36,1.7-12.6,4.88-16.46,10.21a34.64,34.64,0,0,1-3.07,3.78C898.72,343.43,900.48,343.28,902.24,343.24Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M902.24,342.24a6.19,6.19,0,0,1,2.23.23,9.73,9.73,0,0,1,2.82,2.12,10.05,10.05,0,0,0,9.54,1.85,12.58,12.58,0,0,1,3.59-1c1.91,0,3.56,1.4,4.55,3s1.5,3.5,2.35,5.21,2.21,3.33,4.08,3.75A7.14,7.14,0,0,1,934,358a3.68,3.68,0,0,1,1.12,1.55c1.56,3.37,2.8,7.35,6.13,9a9.17,9.17,0,0,0,3.91.85,8.17,8.17,0,0,0,4-.72,7.66,7.66,0,0,0,2.94-2.93c2.08-3.44,2.32-7.7,1.83-11.69A32.16,32.16,0,0,0,948.7,340a29.35,29.35,0,0,0-26.85-12.39,37.42,37.42,0,0,0-5.35,1c-6.36,1.7-12.6,4.88-16.46,10.21a34.64,34.64,0,0,1-3.07,3.78C898.72,342.43,900.48,342.28,902.24,342.24Z"
      transform="translate(-49.99 -44.29)"
      fill="#3f3d56"
    />
    <path
      d="M876.74,398.2s1.17,9.34-2.83,11.67S876.74,398.2,876.74,398.2Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M961.57,470.54s9.5-14,10.84-10S961.57,470.54,961.57,470.54Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M962.24,475.2s9.37-11.5,10.27-7S962.24,475.2,962.24,475.2Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M934.72,461.51a15.21,15.21,0,0,1-9.42-3.1l-.82,0a14.8,14.8,0,0,1-10.29,3.87A14.6,14.6,0,0,1,903.52,458l-1.09,0a15.71,15.71,0,0,1-20.28-.37l-3.91-.07s4.58,12.2,1.84,19.81l66.83,1.19a95.17,95.17,0,0,1,.48-19.63v-.09l-3.67-.07A15.38,15.38,0,0,1,934.72,461.51Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M934.72,463.51a15.21,15.21,0,0,1-9.42-3.1l-.82,0a14.8,14.8,0,0,1-10.29,3.87A14.6,14.6,0,0,1,903.52,460l-1.09,0a15.71,15.71,0,0,1-20.28-.37l-3.91-.07s4.58,12.2,1.84,19.81l66.83,1.19a95.17,95.17,0,0,1,.48-19.63v-.09l-3.67-.07A15.38,15.38,0,0,1,934.72,463.51Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M934.72,462.51a15.21,15.21,0,0,1-9.42-3.1l-.82,0a14.8,14.8,0,0,1-10.29,3.87A14.6,14.6,0,0,1,903.52,459l-1.09,0a15.71,15.71,0,0,1-20.28-.37l-3.91-.07s4.58,12.2,1.84,19.81l66.83,1.19a95.17,95.17,0,0,1,.48-19.63v-.09l-3.67-.07A15.38,15.38,0,0,1,934.72,462.51Z"
      transform="translate(-49.99 -44.29)"
      fill="#3f3d56"
    />
    <path
      d="M931.75,395.83s14.07.9,14.16,2.9S931.75,395.83,931.75,395.83Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M897.57,387.3s-14.07.9-14.16,2.9S897.57,387.3,897.57,387.3Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M951.34,428.19c-.14-.1-.28-.18-.42-.27,3.6,3.24,3,10.32-1.42,16.16s-11.13,8.27-15.21,5.65c.13.11.24.23.38.34,4,3.06,11,.66,15.62-5.38S955.36,431.26,951.34,428.19Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M874.05,443.33c-3.56-6.42-3.1-13.51.93-16.2-.15.07-.31.13-.46.21-4.42,2.46-5,9.83-1.34,16.47s10.26,10,14.68,7.58a3.83,3.83,0,0,0,.42-.28C883.87,453.11,877.61,449.75,874.05,443.33Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M878.81,389.19h0l-1.29,2-3.29-1.75,1.73-2.66A7.25,7.25,0,0,1,878.81,389.19Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M857.91,463.2s2.93-13.78-1-18.16-2.67-27.34,3.33-26.84,15,18.66,13.5,22.5-7.17,23.5-7.17,23.5Z"
      transform="translate(-49.99 -44.29)"
      fill="#fbbebe"
    />
    <path
      d="M952,363.78a7.66,7.66,0,0,1-2.94,2.93,8.17,8.17,0,0,1-4,.72,9.17,9.17,0,0,1-3.91-.85c-3.33-1.66-4.57-5.64-6.13-9A3.68,3.68,0,0,0,934,356a7.14,7.14,0,0,0-2.57-.63c-1.87-.42-3.22-2.05-4.08-3.75s-1.37-3.58-2.35-5.21-2.64-3.06-4.55-3a12.29,12.29,0,0,0-3.59,1.05,10.08,10.08,0,0,1-9.54-1.86,9.73,9.73,0,0,0-2.82-2.12,6.19,6.19,0,0,0-2.23-.23c-1.15,0-2.29.11-3.44.2a25.14,25.14,0,0,1-1.83,2.14c1.75-.15,3.51-.3,5.27-.34a6.19,6.19,0,0,1,2.23.23,9.73,9.73,0,0,1,2.82,2.12,10.08,10.08,0,0,0,9.54,1.86,12.29,12.29,0,0,1,3.59-1.05c1.91,0,3.56,1.4,4.55,3s1.5,3.5,2.35,5.21,2.21,3.33,4.08,3.75A7.14,7.14,0,0,1,934,358a3.68,3.68,0,0,1,1.12,1.55c1.56,3.37,2.8,7.35,6.13,9a9.17,9.17,0,0,0,3.91.85,8.17,8.17,0,0,0,4-.72,7.66,7.66,0,0,0,2.94-2.93,16.59,16.59,0,0,0,2-9.26A15.28,15.28,0,0,1,952,363.78Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <ellipse cx="812.35" cy="423.74" rx="9" ry="6.1" fill="#575a89" />
    <circle cx="518.99" cy="454.79" r="308.5" fill="#5686fc" />
    <path
      d="M730.85,654.11c0,48.7-76.56,4.16-158.64,4.16s-165.1,42.7-165.1-6c0-27.77,26.46-66.39,64.42-94.44h0c28.6-21.14,63.72-36.28,99-36.28,36.28,0,71.82,16.39,100.17,38.89C706.48,588.81,730.85,626.93,730.85,654.11Z"
      transform="translate(-49.99 -44.29)"
      fill="#444053"
    />
    <path
      d="M670.69,560.42c-43.63-6.57-122.54-14.58-199.16-2.61,28.6-21.14,63.72-36.28,99-36.28C606.8,521.53,642.34,537.92,670.69,560.42Z"
      transform="translate(-49.99 -44.29)"
      fill="#f6f8fb"
    />
    <path
      d="M407.11,281.31s-92.93,59.41-92.17,152.34S407.11,281.31,407.11,281.31Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.05"
    />
    <path
      d="M877.36,113.52s-84.2-5.07-74.27,53.93c0,0-2,10.42,7.48,15.16,0,0,.15-4.37,8.63-2.89a39,39,0,0,0,9.15.44,19,19,0,0,0,11.18-4.62h0s23.67-9.77,32.88-48.46c0,0,6.81-8.44,6.54-10.6l-14.21,6.06s4.85,10.25,1,18.77c0,0-.46-18.39-3.19-18-.55.09-7.38,3.55-7.38,3.55s8.35,17.86,2,30.83c0,0,2.39-22-4.66-29.54l-10,5.84s9.76,18.44,3.14,33.49c0,0,1.7-23.08-5.24-32.07l-9.07,7.07s9.17,18.18,3.58,30.66c0,0-.73-26.87-5.54-28.9,0,0-7.93,7-9.14,9.87,0,0,6.28,13.19,2.39,20.15,0,0-2.39-17.9-4.35-18,0,0-7.9,11.86-8.73,20,0,0,.35-12.1,6.81-21.13,0,0-7.64,1.31-12.09,6.27,0,0,1.23-8.39,14-9.12,0,0,6.53-9,8.28-9.54,0,0-12.75-1.07-20.48,2.36,0,0,6.8-7.91,22.81-4.32l9-7.3s-16.78-2.3-23.9.24c0,0,8.19-7,26.31-1.9l9.75-5.83s-14.31-3.08-22.84-2c0,0,9-4.85,25.69.41l7-3.13s-10.49-2.06-13.56-2.38-3.23-1.18-3.23-1.18A36.35,36.35,0,0,1,862.83,120S877.61,114.45,877.36,113.52Z"
      transform="translate(-49.99 -44.29)"
      fill="#5686fc"
    />
    <path
      d="M791,87.29s-38-2.3-33.56,24.36c0,0-.89,4.71,3.38,6.85,0,0,.06-2,3.9-1.3a18.06,18.06,0,0,0,4.13.2,8.69,8.69,0,0,0,5.06-2.09h0s10.69-4.42,14.85-21.9c0,0,3.08-3.81,3-4.79l-6.42,2.74s2.2,4.63.47,8.48c0,0-.21-8.31-1.44-8.11-.25,0-3.34,1.6-3.34,1.6s3.78,8.07.93,13.93c0,0,1.08-9.94-2.1-13.35l-4.52,2.64s4.41,8.34,1.42,15.14c0,0,.76-10.43-2.37-14.49l-4.1,3.19s4.14,8.21,1.62,13.85c0,0-.33-12.14-2.51-13.06,0,0-3.58,3.16-4.13,4.46,0,0,2.84,6,1.08,9.11,0,0-1.08-8.09-2-8.12,0,0-3.57,5.35-3.94,9a19.48,19.48,0,0,1,3.07-9.55,10.71,10.71,0,0,0-5.46,2.83s.55-3.79,6.34-4.12c0,0,2.95-4.06,3.74-4.31,0,0-5.76-.48-9.25,1.07,0,0,3.07-3.58,10.31-2l4-3.29s-7.58-1-10.8.1c0,0,3.7-3.16,11.89-.85l4.4-2.64s-6.46-1.39-10.32-.89c0,0,4.07-2.19,11.61.19l3.15-1.42s-4.74-.93-6.12-1.07-1.47-.53-1.47-.53a16.39,16.39,0,0,1,8.9,1S791.11,87.71,791,87.29Z"
      transform="translate(-49.99 -44.29)"
      fill="#5686fc"
    />
    <ellipse
      cx="1073.09"
      cy="725.46"
      rx="26.93"
      ry="4.55"
      fill="#5686fc"
      opacity="0.1"
    />
    <ellipse
      cx="46.77"
      cy="801.15"
      rx="26.93"
      ry="4.55"
      fill="#5686fc"
      opacity="0.1"
    />
    <ellipse
      cx="203.1"
      cy="806.86"
      rx="26.93"
      ry="4.55"
      fill="#5686fc"
      opacity="0.1"
    />
    <ellipse cx="1014.15" cy="774.22" rx="40.21" ry="6.8" fill="#5686fc" />
    <path
      d="M1080.76,807.4a11.73,11.73,0,0,0,3.84-5.79c.49-2.29-.49-5.05-2.68-5.89-2.46-.94-5.09.77-7.08,2.49s-4.28,3.68-6.89,3.32a10.47,10.47,0,0,0,3.24-9.81,4.12,4.12,0,0,0-.9-2c-1.37-1.46-3.84-.84-5.48.31-5.2,3.66-6.65,10.72-6.68,17.08-.52-2.29-.08-4.68-.09-7s-.66-5-2.64-6.23a8,8,0,0,0-4-.94c-2.34-.09-4.94.14-6.54,1.85-2,2.13-1.47,5.69.26,8s4.35,3.81,6.76,5.42a15,15,0,0,1,4.84,4.61,4.83,4.83,0,0,1,.36.83h14.65A40.77,40.77,0,0,0,1080.76,807.4Z"
      transform="translate(-49.99 -44.29)"
      fill="#5686fc"
    />
    <path
      d="M109.33,723.55s5.49,7.18-2.54,18-14.65,20-12,26.76c0,0,12.11-20.14,22-20.43S120.17,735.66,109.33,723.55Z"
      transform="translate(-49.99 -44.29)"
      fill="#5686fc"
    />
    <path
      d="M109.33,723.55a9,9,0,0,1,1.12,2.25c9.62,11.3,14.74,21.85,5.5,22.11-8.62.25-19,15.65-21.43,19.54a9.3,9.3,0,0,0,.3.89s12.11-20.14,22-20.43S120.17,735.66,109.33,723.55Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M119.54,732.7c0,2.53-.29,4.58-.64,4.58s-.63-2-.63-4.58.35-1.34.71-1.34S119.54,730.17,119.54,732.7Z"
      transform="translate(-49.99 -44.29)"
      fill="#ffd037"
    />
    <path
      d="M123,735.72c-2.22,1.21-4.15,1.94-4.32,1.63s1.5-1.53,3.72-2.74,1.34-.33,1.51,0S125.26,734.51,123,735.72Z"
      transform="translate(-49.99 -44.29)"
      fill="#ffd037"
    />
    <path
      d="M80.31,723.55s-5.49,7.18,2.53,18,14.65,20,12,26.76c0,0-12.12-20.14-22-20.43S69.46,735.66,80.31,723.55Z"
      transform="translate(-49.99 -44.29)"
      fill="#5686fc"
    />
    <path
      d="M80.31,723.55a8.63,8.63,0,0,0-1.12,2.25c-9.62,11.3-14.75,21.85-5.5,22.11,8.61.25,19,15.65,21.42,19.54a9.24,9.24,0,0,1-.29.89s-12.12-20.14-22-20.43S69.46,735.66,80.31,723.55Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.1"
    />
    <path
      d="M70.1,732.7c0,2.53.28,4.58.63,4.58s.63-2,.63-4.58-.35-1.34-.7-1.34S70.1,730.17,70.1,732.7Z"
      transform="translate(-49.99 -44.29)"
      fill="#ffd037"
    />
    <path
      d="M66.59,735.72c2.22,1.21,4.16,1.94,4.33,1.63s-1.5-1.53-3.72-2.74-1.35-.33-1.51,0S64.37,734.51,66.59,735.72Z"
      transform="translate(-49.99 -44.29)"
      fill="#ffd037"
    />
    <path
      d="M71.85,767.4s15.36-.47,20-3.77,23.63-7.23,24.78-2,23.08,26.3,5.74,26.44-40.29-2.71-44.91-5.52S71.85,767.4,71.85,767.4Z"
      transform="translate(-49.99 -44.29)"
      fill="#a8a8a8"
    />
    <path
      d="M122.66,786.28c-17.34.14-40.29-2.71-44.91-5.52-3.52-2.14-4.92-9.83-5.39-13.38l-.51,0s1,12.39,5.59,15.2,27.57,5.66,44.91,5.52c5,0,6.73-1.83,6.64-4.46C128.29,785.25,126.39,786.25,122.66,786.28Z"
      transform="translate(-49.99 -44.29)"
      opacity="0.2"
    />
    <path
      d="M459.3,458.63c5.87-.33,33.5-2.41,51.05-12.42a19.89,19.89,0,0,1,9.27-2.73c5.58-.16,12,2.17,7.89,15.21-6.66,21.33-45.33,45.33-69.33,44-23.08-1.28-50.46-10.58-68.54-43.28a20,20,0,0,1-2.47-10.29c.21-6.6,2.61-14.87,15-5.65,16.74,12.45,48.5,14.81,54.87,15.16A21.11,21.11,0,0,0,459.3,458.63Z"
      transform="translate(-49.99 -44.29)"
      fill="#444053"
    />
    <path
      d="M681.3,458.63c5.87-.33,33.5-2.41,51.05-12.42a19.89,19.89,0,0,1,9.27-2.73c5.58-.16,12,2.17,7.89,15.21-6.66,21.33-45.33,45.33-69.33,44-23.08-1.28-50.46-10.58-68.54-43.28a20,20,0,0,1-2.47-10.29c.21-6.6,2.61-14.87,15-5.65,16.74,12.45,48.5,14.81,54.87,15.16A21.11,21.11,0,0,0,681.3,458.63Z"
      transform="translate(-49.99 -44.29)"
      fill="#444053"
    />
  </svg>
);

const NoInvitations = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    width="100%"
    height="100%"
    viewBox="0 0 576.49928 493.5"
  >
    <path
      d="M481.17233,691.60038c9.25458-7.82,14.87595-20.17341,13.40175-32.19951s-10.605-23.08177-22.44888-25.63556-25.34517,4.51552-28.94256,16.08527c-1.97981-22.306-4.26119-45.54663-16.12049-64.54228-10.73831-17.2001-29.33726-29.50744-49.49431-31.70921s-41.37985,6.11408-53.95107,22.0238-15.64923,39.03914-6.84467,57.3048c6.486,13.45569,18.43551,23.46957,30.95562,31.61638a199.78578,199.78578,0,0,0,136.64075,29.89252"
      transform="translate(-311.75036 -203.25)"
      fill="#f2f2f2"
    />
    <path
      d="M343.54974,560.17414A326.87926,326.87926,0,0,1,389.10355,605.409a327.83254,327.83254,0,0,1,51.30832,85.74145c.92389,2.264-2.75246,3.24952-3.66608,1.0107a324.46215,324.46215,0,0,0-29.64717-56.09367,325.69973,325.69973,0,0,0-66.23723-73.20495c-1.898-1.54556.806-4.22115,2.68835-2.68834Z"
      transform="translate(-311.75036 -203.25)"
      fill="#fff"
    />
    <path
      d="M487.56461,691.60038c-9.25458-7.82-14.87595-20.17341-13.40175-32.19951s10.605-23.08177,22.44888-25.63556,25.34518,4.51552,28.94256,16.08527c1.97982-22.306,4.26119-45.54663,16.1205-64.54228,10.7383-17.2001,29.33725-29.50744,49.49431-31.70921s41.37984,6.11408,53.95106,22.0238,15.64923,39.03914,6.84468,57.3048c-6.486,13.45569-18.43552,23.46957-30.95563,31.61638a199.78578,199.78578,0,0,1-136.64075,29.89252"
      transform="translate(-311.75036 -203.25)"
      fill="#f2f2f2"
    />
    <path
      d="M625.18721,560.17414A326.87878,326.87878,0,0,0,579.63339,605.409a327.83254,327.83254,0,0,0-51.30832,85.74145c-.92389,2.264,2.75246,3.24952,3.66608,1.0107a325.98749,325.98749,0,0,1,95.8844-129.29862c1.898-1.54556-.806-4.22115-2.68834-2.68834Z"
      transform="translate(-311.75036 -203.25)"
      fill="#fff"
    />
    <circle cx="203.27678" cy="191" r="31" fill="#f2f2f2" />
    <path
      d="M419.4457,287.3877H633.02714V299.073H446.71128a83.41834,83.41834,0,0,0-83.41857,83.41839V515.25H339.92222a3.89516,3.89516,0,0,1-3.89508-3.89508V370.80609A83.41833,83.41833,0,0,1,419.4457,287.3877Z"
      transform="translate(-311.75036 -203.25)"
      fill="#f2f2f2"
    />
    <path
      d="M460.52714,692.25V514.75h52v177.5a4.50508,4.50508,0,0,1-4.5,4.5h-43A4.50508,4.50508,0,0,1,460.52714,692.25Z"
      transform="translate(-311.75036 -203.25)"
      fill="#3f3d56"
    />
    <path
      d="M325.02714,511.25V366.91553A86.76355,86.76355,0,0,1,411.69242,280.25H632.02714v236h-302A5.00573,5.00573,0,0,1,325.02714,511.25Zm305-229H411.69242a84.76141,84.76141,0,0,0-84.66528,84.66553V511.25a3.00328,3.00328,0,0,0,3,3h300Z"
      transform="translate(-311.75036 -203.25)"
      fill="#3f3d56"
    />
    <path
      d="M515.02714,410.25a18.02031,18.02031,0,0,1-18-18v-129a3.00328,3.00328,0,0,0-3-3h-70a5.0058,5.0058,0,0,1-5-5v-47a5.0058,5.0058,0,0,1,5-5h104a5.00573,5.00573,0,0,1,5,5v184A18.02031,18.02031,0,0,1,515.02714,410.25Z"
      transform="translate(-311.75036 -203.25)"
      fill="#5686fc"
    />
    <path
      d="M640.02714,278.25h0a56.88093,56.88093,0,0,1,57,56.76144V499.32108h112a16.96465,16.96465,0,0,1,17,16.92887h-243V335.01143A56.88093,56.88093,0,0,1,640.02714,278.25Z"
      transform="translate(-311.75036 -203.25)"
      fill="#3f3d56"
    />
    <path
      d="M626.34909,371.81749l11.80284,48.75606L869.03313,364.682l-11.80284-48.75606a3.6384,3.6384,0,0,0-2.35767-2.59508,3.59409,3.59409,0,0,0-1.33406-.20075L720.07937,244.02819a3.682,3.682,0,0,0-4.65628,1.11925l-64.31987,89.69375L626.85528,368.664a.51379.51379,0,0,0-.089.41825A3.64176,3.64176,0,0,0,626.34909,371.81749Z"
      transform="translate(-311.75036 -203.25)"
      fill="#fff"
    />
    <path
      d="M626.7663,369.08226a.48973.48973,0,0,0,.20314.31583.55943.55943,0,0,0,.43331.08552.53586.53586,0,0,0,.29889-.20727l.08326-.11537,1.26254-1.76554,22.92889-31.96427,64.30082-89.6732a2.6198,2.6198,0,0,1,3.32194-.79624l132.42537,68.56666,1.18838.6168a1.29216,1.29216,0,0,0,.14733.05165,1.61549,1.61549,0,0,1,.27147-.026.51364.51364,0,0,0,.28983-.24474.524.524,0,0,0-.21883-.7087l-.16408-.08726L720.07937,244.02819a3.682,3.682,0,0,0-4.65628,1.11925l-64.31987,89.69375L626.85528,368.664A.51379.51379,0,0,0,626.7663,369.08226Z"
      transform="translate(-311.75036 -203.25)"
      fill="#3f3d56"
    />
    <path
      d="M696.10724,374.05386l5.13934.57012,38.14252,4.22535,25.28583,2.79936,1.49358.166,31.55217-24.64477,1.20883-.944,7.45235-5.82019,26.5135-20.70629.15919-1.45441,9.43044-85.11413a4.4539,4.4539,0,0,0-3.92912-4.91152L712.7,224.27763a4.456,4.456,0,0,0-4.91157,3.9292L701.138,288.24439l-3.689,33.28581L694.149,351.30867l-1.52976,13.82919-.44637,4.00573A4.45691,4.45691,0,0,0,696.10724,374.05386Z"
      transform="translate(-311.75036 -203.25)"
      fill="#e6e6e6"
    />
    <path
      d="M730.69234,299.44776l54.51668,6.03806,19.33354,2.14069a6.53968,6.53968,0,1,0,1.43979-12.99988l-24.04683-2.66322-49.79941-5.52188a6.54306,6.54306,0,0,0-1.44377,13.00623Z"
      transform="translate(-311.75036 -203.25)"
      fill="#fff"
    />
    <path
      d="M727.58833,323.56377c.14068.02515.28136.05031.42455.06411l63.28515,7.0109,10.5663,1.17291a6.54214,6.54214,0,0,0,1.43855-13.005l-15.27834-1.69033-50.13045-5.5548-8.43621-.93485a6.53913,6.53913,0,0,0-1.86955,12.937Z"
      transform="translate(-311.75036 -203.25)"
      fill="#fff"
    />
    <path
      d="M720.42587,344.94759a6.53866,6.53866,0,0,0,4.88047,3.12537l25.9387,2.87281,46.19708,5.118.01018-.00247,1.47721.16462,7.45235-5.82019a6.47057,6.47057,0,0,0,.0011-1.33,6.5548,6.5548,0,0,0-5.78686-5.82386l-6.41729-.713-25.457-2.81712-18.31689-2.0315-23.66022-2.62223a6.54,6.54,0,0,0-6.31878,9.87953Z"
      transform="translate(-311.75036 -203.25)"
      fill="#fff"
    />
    <path
      d="M756.8588,269.96954l13.5644,1.50232,5.99124.66537,9.05013,1.00159a6.54214,6.54214,0,0,0,1.43855-13.005l-28.59932-3.16545a6.54059,6.54059,0,1,0-1.445,13.00113Z"
      transform="translate(-311.75036 -203.25)"
      fill="#fff"
    />
    <path
      d="M645.9437,306.1818l16.53736,68.3138,27.60123,5.24823,25.532,4.86089,27.39356,5.21238,8.753,1.6657a3.6733,3.6733,0,0,0,2.93957-.71161l7.02206-5.48451,4.44605-3.472,31.55217-24.64477-20.062-82.87362a4.40272,4.40272,0,0,0-1.24424-2.15908,4.44864,4.44864,0,0,0-4.12489-1.11718L649.22,300.81267A4.45037,4.45037,0,0,0,645.9437,306.1818Z"
      transform="translate(-311.75036 -203.25)"
      fill="#5686fc"
    />
    <path
      d="M683.86407,360.52788a6.54613,6.54613,0,0,0,7.89577,4.818l72.2144-17.48162a6.54974,6.54974,0,0,0,4.818-7.89578,2.09959,2.09959,0,0,0-.0705-.24672,6.53879,6.53879,0,0,0-7.82527-4.5713l-72.2144,17.48161A6.54613,6.54613,0,0,0,683.86407,360.52788Z"
      transform="translate(-311.75036 -203.25)"
      fill="#fff"
    />
    <path
      d="M690.08229,379.74383l25.532,4.86089L769.69885,371.512a6.54051,6.54051,0,1,0-3.07775-12.7138l-72.21439,17.48162a6.49388,6.49388,0,0,0-3.74749,2.51147A6.5835,6.5835,0,0,0,690.08229,379.74383Z"
      transform="translate(-311.75036 -203.25)"
      fill="#fff"
    />
    <path
      d="M743.00785,389.8171l8.753,1.6657a3.6733,3.6733,0,0,0,2.93957-.71161l7.02206-5.48451Z"
      transform="translate(-311.75036 -203.25)"
      fill="#fff"
    />
    <path
      d="M698.41482,323.89664a6.54611,6.54611,0,0,0,7.89577,4.818l27.97037-6.77105a6.54973,6.54973,0,0,0,4.818-7.89577,6.46594,6.46594,0,0,0-1.20489-2.48625,6.5454,6.5454,0,0,0-6.69088-2.33178l-27.97037,6.77105a6.54142,6.54142,0,0,0-4.818,7.89577Z"
      transform="translate(-311.75036 -203.25)"
      fill="#fff"
    />
    <path
      d="M715.61222,384.60434l27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357Zm81.83767-28.539.26672,1.10181,1.21521-.9448Zm-81.83767,28.539,27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357Zm0,0,27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357Zm-89.26313-12.78685,30.916,127.71019a3.66655,3.66655,0,0,0,4.42206,2.69835l223.76079-54.16788a3.6663,3.6663,0,0,0,2.69835-4.42206l-30.916-127.71018a3.6384,3.6384,0,0,0-2.35767-2.59508,3.59409,3.59409,0,0,0-1.33406-.20075,3.45812,3.45812,0,0,0-1.5141.3983,3.17906,3.17906,0,0,0-.60724.37708l-18.36413,14.33976-26.67024,20.83345-8.93478,6.97911.00182.00751-.00769.00186-32.7657,25.578-5.41664,4.23905-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357L690.656,378.79172,630.59485,367.362a3.59025,3.59025,0,0,0-1.54741.03342,3.66988,3.66988,0,0,0-1.78823,1.03592,4.11057,4.11057,0,0,0-.49291.65091A3.64176,3.64176,0,0,0,626.34909,371.81749Zm89.26313,12.78685,27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357Zm0,0,27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357Zm0,0,27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357Z"
      transform="translate(-311.75036 -203.25)"
      fill="#fff"
    />
    <path
      d="M715.61222,384.60434l27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357Zm81.83767-28.539.26672,1.10181,1.21521-.9448Zm-81.83767,28.539,27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357Zm0,0,27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357ZM627.7849,369.161l.13589.102c.02275-.03727.06233-.07063.09239-.10968a2.64256,2.64256,0,0,1,2.38507-.76779l59.68567,11.354,25.5283,4.86479,27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357L690.656,378.79172,630.59485,367.362a3.59025,3.59025,0,0,0-1.54741.03342Zm-1.43581,2.65652,30.916,127.71019a3.66655,3.66655,0,0,0,4.42206,2.69835l223.76079-54.16788a3.6663,3.6663,0,0,0,2.69835-4.42206l-30.916-127.71018a3.6384,3.6384,0,0,0-2.35767-2.59508,3.59409,3.59409,0,0,0-1.33406-.20075,3.45812,3.45812,0,0,0-1.5141.3983,3.17906,3.17906,0,0,0-.60724.37708l-18.36413,14.33976-26.67024,20.83345-8.93478,6.97911.00182.00751-.00769.00186-32.7657,25.578-5.41664,4.23905-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357L690.656,378.79172,630.59485,367.362a3.59025,3.59025,0,0,0-1.54741.03342,3.66988,3.66988,0,0,0-1.78823,1.03592,4.11057,4.11057,0,0,0-.49291.65091A3.64176,3.64176,0,0,0,626.34909,371.81749Zm1.0196-.24682a2.59762,2.59762,0,0,1,.46152-2.19054.34094.34094,0,0,1,.09058-.11714c.02275-.03727.06233-.07063.09239-.10968a2.64256,2.64256,0,0,1,2.38507-.76779l59.68567,11.354,25.5283,4.86479,27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585,4.44395-3.47195,31.54686-24.64821,1.21521-.9448,7.44662-5.81748,26.5182-20.70938,19.17121-14.97157a2.60368,2.60368,0,0,1,.98714-.477,1.99722,1.99722,0,0,1,.30518-.05006,1.61549,1.61549,0,0,1,.27147-.026,2.67893,2.67893,0,0,1,.90068.14691,2.625,2.625,0,0,1,1.68605,1.85318l30.916,127.71019a2.61952,2.61952,0,0,1-1.93138,3.16522L661.4422,501.21416a2.61809,2.61809,0,0,1-3.1575-1.93331Zm88.24353,13.03367,27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357Zm0,0,27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357Zm0,0,27.398,5.21358,8.75042,1.66643a3.68877,3.68877,0,0,0,2.938-.71124l7.02714-5.48585-2.46594.59695-5.20559,4.061a2.63556,2.63556,0,0,1-2.09887.5081l-6.47926-1.23238-27.398-5.21357Z"
      transform="translate(-311.75036 -203.25)"
      fill="#3f3d56"
    />
    <path
      d="M827.1291,422.96742a8.12818,8.12818,0,0,1,5.98077-9.80128l28.24156-6.8367a8.119,8.119,0,0,1,3.82051,15.78205l-28.24156,6.8367A8.12818,8.12818,0,0,1,827.1291,422.96742Z"
      transform="translate(-311.75036 -203.25)"
      fill="#5686fc"
    />
    <circle cx="203.27678" cy="189" r="7" fill="#fff" />
  </svg>
);
const content: { [key in EmptyStateType]: IEmptyStateConfig } = {
  default: {
    title: "We found no items",
    illustration: <NoData></NoData>
  },
  noSourceEntities: {
    title: "No source entities found",
    description:
      "The reason can be because you haven't added a data source, or your CMS hasn't pushed data to Enterspeed yet.",
    illustration: <NoData></NoData>
  },
  noReceivedInvitations: {
    title: "You haven't received any invitations.",
    illustration: <NoInvitations></NoInvitations>
  },
  noSentInvitations: {
    title: "No send invitations found",
    illustration: <NoInvitations></NoInvitations>
  },
  noDomains: {
    title:
      "No domains found. Please create a new domain in the Domains-section.",
    illustration: <NoData></NoData>
  },
  noSchemas: {
    title: "We found no schemas",
    illustration: <NoData></NoData>
  },
  noSchemaChanges: {
    title: "No schema changes found for this environment.",
    illustration: <NoData></NoData>
  },
  noSchemasInVersions: {
    title: "We found no schemas",
    illustration: <NoData></NoData>
  },
  noEnvironmentsInVersions: {
    title: "We found no environments",
    illustration: <NoData></NoData>
  },
  viewNotAvailableOnMobile: {
    title: "Oh dang it! We can't show this view.",
    illustration: <SadFace></SadFace>,
    description:
      "This view isn't available on mobile devices. Please use a desktop browser to view this page."
  },
  routeInspectorNoEnvironmentClients: {
    title: "No environment clients found",
    description:
      "You need to create an environment client before you can use the route inspector.",
    illustration: <NoData></NoData>
  },
  routeInspectorNoRoutesFound: {
    title: "No routes found",
    description:
      "We couldn't find any routes for this value. Make sure the route is correct and that you have selected the correct environment client and route type.",
    illustration: <NoData></NoData>
  },
  routeInspectorEnterValuesToSearch: {
    title: "No routes found",
    description:
      "Select environment client, route type and enter a route to search for.",
    illustration: <NoData></NoData>
  },
  tenantHealtNoErrors: {
    title: "Hooray, no errors registered",
    description: (
      <Text>
        No errors in the selected time period. Go to the{" "}
        <Link to={"/settings/logs"}>
          <Button variant="link">Logs page</Button>
        </Link>{" "}
        to see all logs.
      </Text>
    ),
    illustration: <NoErrors />
  },
  noIndexes: {
    title: "No indexes found",
    illustration: <NoData></NoData>
  }
};

export default EmptyState;
